import React from "react";

const Cupping = () => {
    return(
        <div className="m-4">
            <div className="card lg:card-side bg-base-100 shadow-xl">
                <figure><img src="https://images.unsplash.com/photo-1522992319-0365e5f11656?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=187&q=80" alt="Album"/></figure>
                <div className="card-body">
                    <h2 className="card-title">Catación</h2>
                    <p>Aquí apareceran los datos segun lotes y demas.</p>
                    <div className="card-actions justify-end">
                    </div>
                </div>
            </div>

        </div> );
};

export default Cupping;
